/**
 * @generated SignedSource<<0e380b214b36d73d262a36c68804ad54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Permission = "AccountPermission_AZAVAdmin_IsAZAVAccount" | "AccountPermission_AccountMemberManagement_CanInviteOrAddUsersToUserInAccountGroups" | "AccountPermission_Auth_IsBusinessAccount" | "AccountPermission_Auth_usePlacement" | "AccountPermission_System_Root" | "UserInAccountPermission_AuthAdmin_MinimalRead" | "UserInAccountPermission_AuthAdmin_Modify" | "UserInAccountPermission_AuthAdmin_Read" | "UserInAccountPermission_Auth_Modify" | "UserInAccountPermission_Auth_Read" | "UserInAccountPermission_CachingAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Read" | "UserInAccountPermission_Email_Templates" | "UserInAccountPermission_ExternalLicenseAdmin_Modify" | "UserInAccountPermission_ExternalLicenseAdmin_Read" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_GenerateCartLinkAdmin_Modify" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnableAdmin_Modify" | "UserInAccountPermission_LearnableAdmin_Read" | "UserInAccountPermission_LevelDefinitionAdmin_Modify" | "UserInAccountPermission_LevelDefinitionAdmin_Read" | "UserInAccountPermission_LicenseAdmin_Modify" | "UserInAccountPermission_LicenseAdmin_Read" | "UserInAccountPermission_LicenseDefinitionAdmin_Modify" | "UserInAccountPermission_LicenseDefinitionAdmin_Read" | "UserInAccountPermission_LimitedCartDiscountAdmin_Modify" | "UserInAccountPermission_LimitedCartDiscountAdmin_Read" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_MessageDefinitionAdmin_Modify" | "UserInAccountPermission_MessageDefinitionAdmin_Read" | "UserInAccountPermission_MessageDispatchAdmin_Modify" | "UserInAccountPermission_MessageDispatchAdmin_Read" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_OfferAdmin_Read" | "UserInAccountPermission_OfferAdmin_Write" | "UserInAccountPermission_OrderAdmin_Modify" | "UserInAccountPermission_OrderAdmin_Read" | "UserInAccountPermission_ProductAdmin_Modify" | "UserInAccountPermission_ProductAdmin_Read" | "UserInAccountPermission_ReportAdmin_Modify" | "UserInAccountPermission_ReportAdmin_Read" | "UserInAccountPermission_SettingsAdmin_Modify" | "UserInAccountPermission_SettingsAdmin_Read" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_TagAdmin_Modify" | "UserInAccountPermission_TagAdmin_Read" | "UserInAccountPermission_TagAdmin_Select" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TreeUnlockedStateAdmin_Modify" | "UserInAccountPermission_TreeUnlockedStateAdmin_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_UserInAccountAdmin_Modify" | "UserInAccountPermission_UserInAccountAdmin_Read" | "UserInAccountPermission_VimeoVideoSourceAdmin_Modify" | "UserInAccountPermission_VimeoVideoSourceAdmin_Read";
export type permissionBasedNavigation_Query$variables = {};
export type permissionBasedNavigation_Query$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly accounts: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }>;
        readonly permissionsInAccount: ReadonlyArray<Permission>;
        readonly user: {
          readonly name: string;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"generateAppJwt_AuthViewerSchemaFragment">;
    };
  };
};
export type permissionBasedNavigation_Query = {
  response: permissionBasedNavigation_Query$data;
  variables: permissionBasedNavigation_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissionsInAccount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "accounts",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "permissionBasedNavigation_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "generateAppJwt_AuthViewerSchemaFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "permissionBasedNavigation_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "977e0786a4b33e6007a6da171dc3d43b",
    "id": null,
    "metadata": {},
    "name": "permissionBasedNavigation_Query",
    "operationKind": "query",
    "text": "query permissionBasedNavigation_Query {\n  Viewer {\n    Auth {\n      currentUser {\n        permissionsInAccount\n        user {\n          name\n          id\n        }\n        accounts {\n          id\n          name\n        }\n      }\n      ...generateAppJwt_AuthViewerSchemaFragment\n    }\n  }\n}\n\nfragment generateAppJwt_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      id\n    }\n    accounts {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcbb5fef1f77ab2d761589df8891a506";

export default node;
